<template>
  <el-dialog class="yto-dialog" :title="step === 3 ? '绑定成功' : this.dialogTitle" @open="openDialog" @close="closeDialog" :visible.sync="isShow"
  :close-on-click-modal="false" :modal="false">
    <div class="tip-dialog" v-if="step === 3">
      <span class="success-icon">
        <svg-icon icon-class="success"></svg-icon>
      </span>
      <p class="tip-text">{{this.tipText}}</p>
    </div>
    <el-form v-else :inline="true" label-width="100px">
      <el-form-item v-if="step === 1" label="绑定手机号">
        <el-input style="width: 300px;" v-model="userMess.mobile" :disabled="!bindUserMobileInfo.changeStatus"></el-input>
      </el-form-item>
      <el-form-item v-else label="手机号码">
        <el-input style="width: 300px;" :maxlength="11" v-model="mobile"></el-input>
      </el-form-item>
      <el-form-item label="图片验证码">
        <el-input style="width: 192px;" :maxlength="4" v-model="picSmsCode" placeholder="请输入图形验证码"></el-input><img class="picture-sms-code" @click="refreshPic" alt="" :src="src"/>
      </el-form-item>
      <el-form-item label="短信验证码" key="sms1" v-if="step === 1">
        <el-input style="width: 192px;" :maxlength="6" v-model="smsCode" placeholder="请输入短信验证码"></el-input><el-button class="sms-code-btn" @click="sendMessageSmsCode1" :disabled="timeText1 >= 0">{{timeText1 >= 0 ? timeText1 + 's' : '获取验证码'}}</el-button>
      </el-form-item>
      <el-form-item label="短信验证码" key="sms2" v-else>
        <el-input style="width: 192px;" :maxlength="6" v-model="smsCode" placeholder="请输入短信验证码"></el-input><el-button class="sms-code-btn" @click="sendMessageSmsCode2" :disabled="timeText2 >= 0">{{timeText2 >= 0 ? timeText2 + 's' : '获取验证码'}}</el-button>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="padding-bottom:20px;">
      <el-button v-if="step === 3" @click="reLogin" plain>确 定</el-button>
      <el-button v-else @click="closeDialog" plain>取 消</el-button>
      <el-button v-if="step === 1" type="primary" @click="next">下一步</el-button>
      <el-button v-else-if="step === 2" @click="finish" type="primary">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Cookies from 'js-cookie';
import timeText from '@/mixins/timeText';
import { bindUserMobileApi, replaceMobileTempsApi } from '@/api/systemModule/accountSetting/info';
import { getMessageSmsCodeTempsApi, checkBindMobileTempsApi, getPicSmsCodeApi, logoutUtil } from '@/api/systemModule/login';
export default {
  mixins: [timeText],
  components: {},
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    bindUserMobileInfo: {}
  },
  watch: {
    value(val) {
      this.isShow = val;
    }
  },
  data() {
    return {
      timeText1: '获取验证码',
      timeText2: '获取验证码',
      isShow: this.value,
      step: 1,
      src: '',
      mobile: '',
      picSmsCode: '',
      smsCode: '',
      currentMobileSmsCode: '',
      dialogTitle: '更换绑定手机',
      tipText: '绑定手机更换成功，您可以使用新手机登录'
    };
  },
  created() {
    let time = Cookies.get('smsCode5');
    if (time) {
      let showTime = 60 - parseInt((new Date().getTime() - new Date(time).getTime()) / 1000);
      this.timeText1 = showTime;
      this.setText('timeText1');
    };
    if (this.bindUserMobileInfo.changeStatus) {
      this.dialogTitle = this.bindUserMobileInfo.title;
      this.tipText = this.bindUserMobileInfo.tipText;
      this.step = this.bindUserMobileInfo.step;
    }
  },
  methods: {
    openDialog() {
      this.refreshPic();
      this.mobile = '';
      this.picSmsCode = '';
      this.smsCode = '';
      this.currentMobileSmsCode = '';
    },
    // 完成
    finish() {
      if (this.mobile) {
        let reg = /(^1\d{10}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$)/;
        if (!reg.test(this.mobile)) {
          this.$message.error('手机号格式不正确');
          return false;
        }
      };
      if (this.bindUserMobileInfo.changeStatus) {
        // 电商平台跳转后绑定手机号
        bindUserMobileApi({
          mobile: this.mobile,
          smsCode: this.smsCode,
          graphicsCode: this.picSmsCode,
          sessionId: this.sessionId
        }).then(response => {
          this.step = 3;
          this.$store.commit('SET_USERINFO', response);
        });
      } else {
        // 更换手机号
        replaceMobileTempsApi({
          mobile: this.mobile,
          smsCode: this.smsCode,
          userName: this.userMess.userName,
          currentMobileSmsCode: this.currentMobileSmsCode
        }).then(res => {
          if(res.success) {
            if(res.data.code) {
              this.$alert(res.data.errorMsg, '提示', {
                confirmButtonText: '确定',
                callback: () => {
                  this.closeDialog();
                }
              });
            } else {
              this.step = 3;
            }
          } else {
            this.$message.error(res.message || '验证失败');
          }
        });
      };
    },
    // 下一步
    next() {
      checkBindMobileTempsApi({
        mobile: this.userMess.userName,
        smsCode: this.smsCode
      }).then(res => {
        if(res.success) {
          this.step = 2;
          this.currentMobileSmsCode = this.smsCode;
          this.picSmsCode = '';
          this.smsCode = '';
          this.refreshPic();
        } else {
          this.$message.error(res.message || '验证失败');
          this.refreshPic();
        }
      });
    },
    // 关闭dialog
    closeDialog() {
      this.step = 1;
      this.isShow = false;
      this.$emit('close', this.isShow);
    },
    reLogin() {
      logoutUtil();
    },
    // 获取图片验证码
    refreshPic() {
      getPicSmsCodeApi().then(response => {
        if (response.base64Img && response.sessionId) {
          this.src = response.base64Img;
          this.sessionId = response.sessionId;
        } else {
          this.$message({
            type: 'warning',
            message: '服务器返回内容有误！'
          });
        }
      });
    },
    // 获取短信验证码
    sendMessageSmsCode1() {
      if (this.picSmsCode === '') {
        this.$message({
          type: 'warning',
          message: '图片验证码不能为空'
        });
        return false;
      }
      getMessageSmsCodeTempsApi({
        sessionId: this.sessionId,
        smsType: 3,
        graphicsCode: this.picSmsCode
      }).then((res) => {
        if(res.success) {
          let time = 60;
          Cookies.set('smsCode5', new Date(), { expires: (1 / (24 * 60)) });
          this.timeText1 = time;
          this.setText('timeText1');
        } else {
          this.$message.error(res.message || '验证码获取失败');
          this.picSmsCode = '';
          this.refreshPic();
        }
      });
    },
    // 获取短信验证码
    sendMessageSmsCode2() {
      if (this.picSmsCode === '') {
        this.$message({
          type: 'warning',
          message: '图片验证码不能为空'
        });
        return false;
      }
      getMessageSmsCodeTempsApi({
        mobile: this.mobile,
        sessionId: this.sessionId,
        smsType: 3,
        graphicsCode: this.picSmsCode
      }).then((res) => {
        if(res.success) {
          let time = 60;
          Cookies.set('smsCode8', new Date(), { expires: (1 / (24 * 60)) });
          this.timeText2 = time;
          this.setText('timeText2');
        } else {
          this.$message.error(res.message || '验证码获取失败');
          this.picSmsCode = '';
          this.refreshPic();
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
</style>
